import React from 'react'
import DashboardMaster from '../../../../dashboard/DashboardMaster'
import PriceContent from './PriceContent'

const AdminPrice = () => {
  return (
    <DashboardMaster>
      <PriceContent />
    </DashboardMaster>
  )
}

export default AdminPrice